export default __webpack_public_path__ + "static/media/d3.da351401.svg";